import { useContext } from "react";

import { BreadcrumbsContext } from "./BreadcrumbsContext";

export function useBreadcrumbsContext() {
  const context = useContext(BreadcrumbsContext);

  if (!context) {
    throw new Error(
      "useBreadcrumbsContext should be wrapped in BreadcrumbsProvider"
    );
  }

  return context;
}
